import type { FaireProductEntity } from "../../entity_types/product";

export const p_6u6en7g74g: FaireProductEntity = {
  token: "p_6u6en7g74g",
  type: "product",
  name: "Natural Sensitive Deodorant (Aluminum Free, No Baking Soda)",
  brandToken: "b_3yerfaqmmt",
  brandName: "Desesh",
  imageUrl:
    "https://cdn.faire.com/fastly/ea8cd30766c7396e049597d670558bbb233e9c70c2f16f87e6293b3bad771d87.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ddb35ce21b4e5beb6e4ab2998843fb3c75c32c0e31ff47144eae152234f950b.png",
    "https://cdn.faire.com/fastly/f2ac6dafa0609bad6df93c2c12235bee6b2f2ced98344f4cc79a4463520825e8.png",
    "https://cdn.faire.com/fastly/8874af16d31a622d2068046505747f74bc91511e0f8703f240450c51f4a6aa6c.jpeg",
    "https://cdn.faire.com/fastly/f5f6d1804c1c3157d2118340eecc96cc29c34108d0a8a7cbbbc4d9d12c513a9f.jpeg",
    "https://cdn.faire.com/fastly/35fd75aa7ae6b1523c471bd8ff9ef43e5e2f682dca9277d02af1861b7ea1d8ae.jpeg",
    "https://cdn.faire.com/fastly/3053f62e40a9210a618f8871d5e7ba365c8cceb1b53ac60627c801175aefb21c.jpeg",
    "https://cdn.faire.com/fastly/acfd5be37a9df73f8d1a66df2296dd21494b627867fcc40e9730748b600193f6.jpeg",
    "https://cdn.faire.com/fastly/a61156be5714e8e5d3b8b95581911716aab30a204b9526ee43d4f2bd62926b84.jpeg",
  ],
  priceDollars: 9.69,
  description:
    "Premium natural aluminum free and baking soda free deodorant for all skin types ready to keep you smelling amazing all day. Designed to effortlessly control odors with non-toxic plant-based ingredients that contain antibacterial and antioxidant properties. This is a concentrated formula, so less is required for each application. Please note however that these are scented with essential oils, which for some people can still cause minor skin irritation if highly sensitive. What's different? Premium quality ingredients, baking soda free, plastic free, aluminum free, phthalate free, paraben free, palm oil free, talc free, no propylene glycol, vegan and cruelty free, compostable packaging, and made in small batches in the United States.\n\n[Note: The creamy texture of the deodorants can sometimes get stuck to the paper tube depending on temperature and humidity. Simply roll them like a rolling pin and then push up]",
  tags: [],
  msrpDollars: 19.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:23.325Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
